/**
 * Created by kb on 2017/11/24.
 */
import {util} from '@/commonJs/util'

export  function subLen(str,len) {
  if (str) {
    return str.length > len ? str.substr(0, len) + "..." : str
  }
  return str;
}


export  function longToTime(time,formart) {
  if (/^[1-9]\d*$/.test(time)) {
    return time.timeformatDate(formart);
  }
  return "";
}

export  function longToWeek(time) {
  if (/^[1-9]\d*$/.test(time)) {
    var arrayWeek = new Array("日", "一", "二", "三", "四", "五", "六");
    return "星期" + arrayWeek[new Date(time).getDay()]
}
  return "";
}



// WEBPACK FOOTER //
// ./src/commonJs/filters.js